import ProvidersList from './ProvidersList';

export default function Telepet() {
    return (
        <ProvidersList
            type="telepet"
            title="Telepet"
            subtitle="Benefícios de telepet dos assinantes."
        />
    );
}
